
import React, { useState, useEffect } from 'react';
import { Button } from '../base/Button';

export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-300 ${
      isScrolled 
        ? 'bg-white/95 backdrop-blur-md shadow-lg' 
        : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://public.readdy.ai/ai/img_res/18fbafa5-fe56-4ee6-aedd-9bee74ac04df.png" 
              alt="BALESTRA Logo"
              className="h-10 w-auto"
            />
            <span className={`ml-3 text-xl font-bold ${
              isScrolled ? 'text-[#0A1628]' : 'text-white'
            }`}>
              BALESTRA
            </span>
          </div>

          {/* Navigation Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-colors duration-300 hover:text-[#00D4FF] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-gray-300'}`}>◆</span>
            <button
              onClick={() => scrollToSection('vpn')}
              className={`font-medium transition-colors duration-300 hover:text-[#00D4FF] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              VPN
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-gray-300'}`}>◆</span>
            <button
              onClick={() => scrollToSection('features')}
              className={`font-medium transition-colors duration-300 hover:text-[#00D4FF] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-gray-300'}`}>◆</span>
            <button
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-colors duration-300 hover:text-[#00D4FF] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
            <span className={`text-xs ${isScrolled ? 'text-gray-400' : 'text-gray-300'}`}>◆</span>
            <button
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-colors duration-300 hover:text-[#00D4FF] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex">
            <Button 
              variant="primary" 
              size="md"
              onClick={() => scrollToSection('contact')}
            >
              Get Started
              <i className="ri-arrow-right-line"></i>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button className={`p-2 ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};
